module.exports = __webpack_public_path__ + "img/cw.47d5eba4.png";